import type { RouteObject } from "react-router-dom";
import HomePage from "../pages/home/page";
import ProductsPage from "../pages/products/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import PaintPage from "../pages/products/paint/page";
import TileAdhesivePage from "../pages/products/tile-adhesive/page";
import GroutPage from "../pages/products/grout/page";
import BondingLiquidPage from "../pages/products/bonding-liquid/page";
import LearnPage from "../pages/learn/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/products/paint",
    element: <PaintPage />,
  },
  {
    path: "/products/tile-adhesive",
    element: <TileAdhesivePage />,
  },
  {
    path: "/products/grout",
    element: <GroutPage />,
  },
  {
    path: "/products/bonding-liquid",
    element: <BondingLiquidPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/learn",
    element: <LearnPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;